import React from 'react'

const AdminDashboard = () => {
    return (
        <div className='bg-white'>
            wlkemwo
        </div>
    )
}

export default AdminDashboard
